// src/js/helpers/ImpactTracking.js
var ImpactTracking = {
  COOKIE_NAME: "issa_impact_params",
  COOKIE_EXPIRY_DAYS: 30,
  // Affiliate page paths (for source attribution)
  AFFILIATE_PAGES: ["/pages/affiliate-offers", "/pages/offers", "/offers"],
  // Parameters to capture
  IMPACT_PARAMS: ["irclickid", "clickid", "irgwc", "utm_source", "utm_medium", "utm_campaign", "utm_content", "utm_term", "ref", "affiliate"],
  /**
   * Initialize tracking - call on page load
   */
  init() {
    this.captureParams();
    this.captureAffiliatePage();
    this.setupFormInterceptors();
    window.ImpactTracking = this;
  },
  /**
   * Check if current page is an affiliate page and store it
   */
  captureAffiliatePage() {
    const currentPath = window.location.pathname;
    const isAffiliatePage = this.AFFILIATE_PAGES.some((path) => currentPath.includes(path));
    if (isAffiliatePage) {
      const existingParams = this.getStoredParams();
      existingParams.affiliate_landing_page = currentPath;
      existingParams.affiliate_landing_url = window.location.href;
      this.setCookie(existingParams);
    }
  },
  /**
   * Capture tracking parameters from URL
   */
  captureParams() {
    const urlParams = new URLSearchParams(window.location.search);
    const trackingParams = {};
    let hasParams = false;
    this.IMPACT_PARAMS.forEach((param) => {
      const value = urlParams.get(param);
      if (value) {
        trackingParams[param] = value;
        hasParams = true;
      }
    });
    urlParams.forEach((value, key) => {
      if (key.startsWith("ir") && !trackingParams[key]) {
        trackingParams[key] = value;
        hasParams = true;
      }
    });
    if (hasParams) {
      this.setCookie(trackingParams);
    }
    return trackingParams;
  },
  /**
   * Set tracking cookie
   */
  setCookie(data) {
    const expires = /* @__PURE__ */ new Date();
    expires.setTime(expires.getTime() + this.COOKIE_EXPIRY_DAYS * 24 * 60 * 60 * 1e3);
    const existingParams = this.getStoredParams();
    const mergedParams = { ...existingParams, ...data };
    const cookieValue = encodeURIComponent(JSON.stringify(mergedParams));
    document.cookie = `${this.COOKIE_NAME}=${cookieValue};expires=${expires.toUTCString()};path=/;SameSite=Lax`;
  },
  /**
   * Get stored tracking parameters
   */
  getStoredParams() {
    const match = document.cookie.match(new RegExp(`${this.COOKIE_NAME}=([^;]+)`));
    if (!match) return {};
    try {
      return JSON.parse(decodeURIComponent(match[1]));
    } catch (e) {
      console.warn("ImpactTracking: Failed to parse cookie", e);
      return {};
    }
  },
  /**
   * Check if we have tracking params stored
   */
  hasStoredParams() {
    return Object.keys(this.getStoredParams()).length > 0;
  },
  /**
   * Get a specific parameter value
   */
  getParam(key) {
    return this.getStoredParams()[key] || null;
  },
  /**
   * Clear stored tracking params
   */
  clearParams() {
    document.cookie = `${this.COOKIE_NAME}=;expires=Thu, 01 Jan 1970 00:00:00 GMT;path=/`;
  },
  /**
   * Setup form interceptors to inject params
   */
  setupFormInterceptors() {
    document.addEventListener("submit", (e) => {
      const form = e.target;
      if (form.action && form.action.includes("/cart/add")) {
        this.injectParamsToForm(form);
      }
    }, true);
    document.querySelectorAll('form[action*="/cart/add"]').forEach((form) => {
      this.ensureHiddenInputs(form);
    });
  },
  /**
   * Inject tracking params into a form
   */
  injectParamsToForm(form) {
    const params = this.getStoredParams();
    if (Object.keys(params).length === 0) return;
    Object.entries(params).forEach(([key, value]) => {
      const inputName = `properties[_${key}]`;
      let input = form.querySelector(`input[name="${inputName}"]`);
      if (!input) {
        input = document.createElement("input");
        input.type = "hidden";
        input.name = inputName;
        form.appendChild(input);
      }
      input.value = value;
    });
  },
  /**
   * Ensure hidden inputs exist in form for tracking params
   */
  ensureHiddenInputs(form) {
    const params = this.getStoredParams();
    Object.entries(params).forEach(([key, value]) => {
      const inputName = `properties[_${key}]`;
      let input = form.querySelector(`input[name="${inputName}"]`);
      if (!input) {
        input = document.createElement("input");
        input.type = "hidden";
        input.name = inputName;
        input.value = value;
        form.appendChild(input);
      }
    });
  },
  /**
   * Get params formatted for API calls
   */
  getParamsForAPI() {
    const params = this.getStoredParams();
    const formatted = {};
    Object.entries(params).forEach(([key, value]) => {
      formatted[`_${key}`] = value;
    });
    return formatted;
  },
  /**
   * Debug: Log current tracking state
   */
  debug() {
    console.group("ImpactTracking Debug");
    console.log("Stored params:", this.getStoredParams());
    console.log("Has params:", this.hasStoredParams());
    console.log("Cookie:", document.cookie.match(new RegExp(`${this.COOKIE_NAME}=([^;]+)`)));
    console.groupEnd();
  }
};
var ImpactTracking_default = ImpactTracking;

// src/js/entry.vbt.js
ImpactTracking_default.init();
var initAffiliateCards = async () => {
  const cards = document.querySelectorAll("[data-affiliate-card]");
  if (!cards.length) return;
  const { default: AffiliateProductCard } = await import("./chunk--AffiliateProductCard-E4BFPRGF.vbt.js");
  cards.forEach((card) => {
    const instance = new AffiliateProductCard(card, "data-affiliate-card");
    instance.init();
  });
};
if (document.readyState === "loading") {
  document.addEventListener("DOMContentLoaded", initAffiliateCards);
} else {
  initAffiliateCards();
}
export {
  ImpactTracking_default as ImpactTracking
};
